import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=19b327e4&"
import script from "./competition.vue?vue&type=script&lang=ts&"
export * from "./competition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports